const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFunctionalCapacity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    className: "appointment-types__type-svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.2 34.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.15,26.78l-3.91-7.73H19.62a1.31,1.31,0,0,1-.18.57,1.23,1.23,0,0,1-.79.6,1.07,1.07,0,0,1-.39.05,1.26,1.26,0,0,1-.59-.17l-4.82-2.78-.28-.2a2,2,0,0,1-.68-1l-.24-.91-1,3.62,4.18,4.19L17,32.12a1.42,1.42,0,0,1,0,.22,2,2,0,0,1,0,.25,1.47,1.47,0,0,1-.46,1.1,1.49,1.49,0,0,1-1.1.46,1.51,1.51,0,0,1-1.11-.46A1.53,1.53,0,0,1,14,33s0-.06,0-.1l-1.73-7.32-2-2h0L8.62,22v3.31l-5,8a1.48,1.48,0,0,1-1,.69l-.15,0H2.44A1.55,1.55,0,0,1,.8,32.81a1.1,1.1,0,0,1,0-.16,1.49,1.49,0,0,1,.21-1L5,25.2V18.9a15.26,15.26,0,0,1,.45-3.43,1.16,1.16,0,0,1,0-.18L7.05,9.36A2,2,0,0,1,8.28,8l.15,0",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.78,3a3.29,3.29,0,0,1,.21.9,2.74,2.74,0,0,1-.7,2.21A2.71,2.71,0,0,1,12.17,7,3.32,3.32,0,0,1,9.86,6.1,3.36,3.36,0,0,1,8.71,3.89a2.76,2.76,0,0,1,.71-2.22A2.69,2.69,0,0,1,11.54.75a3.33,3.33,0,0,1,2.31.92A3.47,3.47,0,0,1,14.78,3",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.57,9.66a3.57,3.57,0,0,1,.54.94,2.25,2.25,0,0,1,.08.24l1.17,4.35h0L19,17.85a1.28,1.28,0,0,1,.61.79,1.48,1.48,0,0,1,.05.41",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.17,
    y: 16.42,
    width: 9.89,
    height: 9.89,
    transform: "translate(-6.3 16.36) rotate(-26.85)",
    className: "appointment-types__type-svg-fill",
    style: {
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.13,30a2.47,2.47,0,1,0,1.75-.72A2.37,2.37,0,0,0,24.13,30Z",
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.81,
    y1: 30.24,
    x2: 38.45,
    y2: 26.36,
    style: {
      fill: "none",
      stroke: "#9d9c9c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionalCapacity);
export default __webpack_public_path__ + "static/media/functional_capacity.4075a5b3d784253254d2eab4495d03ed.svg";
export { ForwardRef as ReactComponent };